module.exports = __webpack_public_path__ + "static/media/hamburger.c0f7f687.svg";